export const __ThisModule__ = 'a-api';
export { ScopeModuleAApi as ScopeModule } from './index.js';